// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guarantee-list__title{margin-bottom:40px;font-family:var(--1ek1u3d);font-size:20px;font-weight:var(--fn4c5m);line-height:24px;letter-spacing:.005em}@media only screen and (min-width:992px){.guarantee-list__title{font-size:36px;line-height:40px;text-align:center}}", ""]);
// Exports
module.exports = exports;
